import { GetAllQueryParamsData } from './models';

function getAllQueryParams() {
  // Create a URL object from the input URL
  const urlObj = new URL(window.location.href);

  // Initialize an object to hold the final parsed result
  const parsedObj: GetAllQueryParamsData = {
    baseUrl: urlObj.origin + urlObj.pathname, // Extract the base URL (without query parameters)
    params: {}, // Initialize an empty object to hold query parameters
  };

  // Get all query parameters from the URL
  const params = new URLSearchParams(urlObj.search);

  // Initialize an object to hold the refinementList
  const refinementList = {};

  // Loop through the query parameters
  params.forEach((value, key) => {
    // Check if the key matches the refinementList pattern
    const match = key.match(/^refinementList\[(.*?)\]\[(\d+)\]$/);
    if (match) {
      // If the key is part of refinementList, process it
      const group = match[1]; // Group name (e.g., "year", "articleTags.name")
      const index = match[2]; // Index of the item in the list

      // If the group doesn't exist in the refinementList, initialize it as an empty array
      if (!refinementList[group]) {
        refinementList[group] = [];
      }

      // Assign the value to the correct index in the group array
      refinementList[group][index] = value;
    }
    // If the key is 'refinementList' (like in URL 2 where the whole object is passed)
    else if (key === 'refinementList') {
      try {
        // Parse the JSON string passed as a query parameter
        const jsonValue = JSON.parse(decodeURIComponent(value));

        // Add the parsed JSON to the refinementList object
        Object.keys(jsonValue).forEach((group) => {
          refinementList[group] = jsonValue[group];
        });
      } catch (e) {
        console.error('Failed to parse refinementList:', e);
      }
    }
    // Handle other query parameters that aren't part of refinementList or configure
    else {
      // Add the parameter to the `params` object
      if (key === 'page') {
        parsedObj.params.page = value;
      } else if (key.startsWith('configure[')) {
        const configureKey = key.match(/^configure\[(.*?)\]$/)[1];
        if (!parsedObj.params.configure) {
          parsedObj.params.configure = {};
        }
        parsedObj.params.configure[configureKey] = value;
      } else {
        // Handle other query parameters like 'query', etc.
        parsedObj.params[key] = value;
      }
    }
  });

  // If any refinementList values were found, add them to the parsed object
  if (Object.keys(refinementList).length > 0) {
    parsedObj.params.refinementList = refinementList;
  }

  // Return the fully parsed object
  return parsedObj;
}

export default getAllQueryParams;
